import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
  courseCard:{  
    margin: '20px',
    boxShadow: 'none',
    padding: '13px',
  },
  courseCardContent:{
    padding: '0 !important',
    '& button':{
      textTransform: 'capitalize',
    },
    '& button:nth-of-type(2)':{
      color: '#1d7dea',
    }
  },
  cardTitle:{
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '27px',
  },
  cardItems:{
    display: 'flex',
    padding: 0,
    '& li':{
      marginRight: 25,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '19px',
      color: '#666',
    },
    '& li:nth-of-type(1)':{
      listStyle: 'none',
    }
  }
});


export { styles}

